import styles from 'styles/modules/Sidescreen.module.scss';
import { useDispatch } from 'react-redux';
import { handleHideSidescreen } from 'store/ux';
import Typo from 'components/Typo';

const SidescreenHeader = ({
    title,
    children,
    closeFn,
    isEditable,
    isAuthorized,
}) => {
    const dispatch = useDispatch();

    const handleClickClose = () => {
        if (closeFn) closeFn();
        dispatch(handleHideSidescreen());
    };

    return (
        <header
            className={[
                styles.header,
                !isAuthorized && isEditable ? styles.headerPublic : '',
            ].join(' ')}
        >
            {isEditable && !isAuthorized ? (
                <p />
            ) : (
                <Typo variant={'h2'} className={styles.title}>
                    {title}
                </Typo>
            )}
            {children}
            <button
                className={styles.close}
                onClick={handleClickClose}
                type="button"
            />
        </header>
    );
};

export default SidescreenHeader;
